<template>
    <!-- 樣式：標題與條列的變更內容 -->
    <div class="mb-2.5 md:mb-5">
        <h4
            v-if="title!==''"
            class="mb-2 mt-4 md:mt-5"
        >
            {{ title }}
        </h4>
        <ul class="border-green-gray">
            <slot />
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.border-green-gray) {
    li {
        @apply p-2.5 md:px-4 text-base xs:text-lg;
    }
    li:not(:first-child) {
        @apply border-t border-dashed border-gray-200 mb-[-0.125rem];
    }
}
</style>
